import "./IInvestStoreConfirmComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {StripeCardSummaryRecord} from "../../../../stripe/models/StripeBillingRecord";
import {ReplaySubject, Subject} from "rxjs";
import {StoreProductStates} from "../../../common/models/StoreProductState";
import {StoreOrderItemLine} from "../../../common/components/order-items/models/StoreOrderItemLine";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {Pair} from "../../../../js/util/UtilFunctions";
import {IInvestStoreViewStore} from "../../service/IInvestStoreViewStore";
import {IInvestStorePriceMapping} from "../../models/IInvestStorePrices";
import {IInvestProductMappings, IInvestStoreProduct} from "../../models/IInvestStoreProduct";

export const StoreConfirm = "iinvestStoreConfirm";

export function storeConfirm(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/confirm/IInvestStoreConfirmComponent.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IInvestStoreConfirmComponentController
    };
}

export class IInvestStoreConfirmComponentController implements IOnInit, IOnDestroy {

    public viewStore: IInvestStoreViewStore;

    public orderItems: Array<StoreOrderItemLine>;
    public card: StripeCardSummaryRecord | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .map((states) => this.buildOrderItems(states))
            .subscribe((items) => {
                this.$scope.$applyAsync(() => this.orderItems = items);
            });
        this.viewStore
            .currentCard
            .takeUntil(this.destroyed$)
            .subscribe((card) => {
                this.$scope.$applyAsync(() => this.card = card);
            });
    }

    private buildOrderItems(states: StoreProductStates<IInvestStoreProduct>): Array<StoreOrderItemLine> {
        return ObjectUtil.keys(states)
                         .map((k) => Pair(k, states[k]))
                         .filter((p) => p[1].selected)
                         .filter((p) => p[1].locked === false)
                         .filter((p) => p[1].inBundle === false)
                         .map((k) => this.buildLineItem(k[0]));
    }

    private buildLineItem(product: IInvestStoreProduct): StoreOrderItemLine {
        const mapping = IInvestProductMappings[product];
        const price = IInvestStorePriceMapping[product];
        const description = mapping.description;
        return {
            description,
            price
        };
    }

    public cardChanged(card: StripeCardSummaryRecord) {
        this.viewStore.updateCard(card);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
